import { useEffect, useRef } from 'react';

/**
 * Hook to set a timeout
 *
 * @param callback - callback to be called after delay
 * @param delay - delay in ms
 */
export const useTimeout = (callback: () => void, delay: number) => {
  const savedCallback = useRef(() => {});

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    const done = () => savedCallback.current();

    if (delay !== null) {
      const id = setTimeout(done, delay);
      return () => clearTimeout(id);
    }
  }, [delay]);
};
